import { type SupplierFacility } from '@frontend/api';

import { RootState } from 'store/configureStore';
import { type ActionWithPayload } from 'store/types';

import { types } from './actions';

type SupplierFacilitySelectorState = {
  hasInitiated: boolean;
  isLoading: boolean;
  supplierFacilities: SupplierFacility[];
};

const initialState: SupplierFacilitySelectorState = {
  isLoading: false,
  hasInitiated: false,
  supplierFacilities: [],
};

type SupplierFacilitySelectorAction =
  | ActionWithPayload<typeof types.FETCH_SUPPLIER_FACILITY_ERROR>
  | ActionWithPayload<
      typeof types.FETCH_SUPPLIER_FACILITY_SUCCESS,
      { supplierFacilities: SupplierFacility[] }
    >
  | ActionWithPayload<typeof types.FETCH_SUPPLIER_FACILITY_REQUEST>;

const reducer = (
  state = initialState,
  action: SupplierFacilitySelectorAction,
): SupplierFacilitySelectorState => {
  const { payload, type } = action;
  switch (type) {
    case types.FETCH_SUPPLIER_FACILITY_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.FETCH_SUPPLIER_FACILITY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_SUPPLIER_FACILITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasInitiated: true,
        supplierFacilities: payload.supplierFacilities,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState): SupplierFacilitySelectorState =>
  state.modules.common.smartComponents.supplierFacilitySelector;

export const getIsLoading = (state: RootState): boolean =>
  getScope(state).isLoading;

export const getHasInitiated = (state: RootState): boolean =>
  getScope(state).hasInitiated;

export const getSupplierFacilities = (state: RootState): SupplierFacility[] =>
  getScope(state).supplierFacilities;
